import React from "react";

const ProjectsIcon = ({
  height = "24px",
  width = "24px",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3.5" y="4.5" width="17" height="5" rx="1.5" stroke="#FFFFFF" />
    <rect x="3.5" y="10.5" width="17" height="5" rx="1.5" stroke="#FFFFFF" />
    <rect x="3.5" y="16.5" width="10" height="4" rx="1.5" stroke="#FFFFFF" />
    <circle cx="17.5" cy="18.5" r="3" stroke="#FFFFFF" />
    <path d="M17.5 17V20" stroke="#FFFFFF" strokeLinecap="round" />
    <path d="M16 18.5H19" stroke="#FFFFFF" strokeLinecap="round" />
  </svg>
);

export default ProjectsIcon;
